// Notifications. Web: Notification API via service worker (only while app/browser is running).
// Capacitor: swap for @capacitor/local-notifications + @capacitor/push-notifications.
export type NotifyPermission = "granted" | "denied" | "default" | "unsupported";

const supported = () => typeof window !== "undefined" && "Notification" in window;

export const notifications = {
  permission(): NotifyPermission {
    return supported() ? (Notification.permission as NotifyPermission) : "unsupported";
  },
  async requestPermission(): Promise<NotifyPermission> {
    if (!supported()) return "unsupported";
    return (await Notification.requestPermission()) as NotifyPermission;
  },
  async show(title: string, body: string, url = "/"): Promise<void> {
    if (!supported() || Notification.permission !== "granted") return;
    try {
      const reg = await navigator.serviceWorker?.getRegistration();
      if (reg) await reg.showNotification(title, { body, icon: "/icon-192.png", badge: "/icon-192.png", data: { url } });
      else new Notification(title, { body, icon: "/icon-192.png" });
    } catch { /* notification display failed silently */ }
  },
};
